import { useState } from "react";
import { t } from 'i18next';
import { accountService } from "@/projects/admin/services/account-service";
import { applicationAccountService } from "@/projects/admin/services/application-account-service";
import { applicationService } from "@/projects/admin/services/application-service";
import { parameterService } from "@/projects/platform/services/parameter-service";
import { PARENT_PARAMETERS_CONSTANTS } from "@/core/constants/parameters/parent-parameters-constant";
import DataGridWrapper from "@/core/wrappers/data-grid-wrapper";
import { RemoveMessage } from "@/core/helper/validation-rule-helper";
import { createCustomStore } from "@/core/wrappers/custom-store-wrapper";

function AccountApplications(props: any) {

    const { accountId } = props;

    const [mainStore] = useState(() => createCustomStore({
        key: ['applicationId', 'accountId', 'parameterAccountTypeId'],
        load: applicationAccountService.getApplicationAccounts,
        byKey: (key, loadOptions) => {
            if (key) {
                loadOptions.filter = [["AccountId", "=", key.accountId]];
            }
        },
        onLoading(loadOptions) {
            if (accountId) {
                loadOptions.filter = [["AccountId", "=", accountId]]
            }
        },
        insert: applicationAccountService.createApplicationAccount,
        remove: applicationAccountService.deleteApplicationAccount,
    }));

    const [accountStore] = useState(() => createCustomStore({
        key: 'id',
        load: accountService.lookupAccounts,
        byKey: (key, loadOptions) => {
            if (key) {
                loadOptions.filter = ["id", "=", key];
            }
        },
        onLoading(loadOptions) {
            loadOptions.filter = ["id", "=", accountId]
        },
    }));

    const [applicationStore] = useState(() => createCustomStore({
        key: 'id',
        cacheRawData: true,
        load: applicationService.lookupApplication,
        byKey: (key, loadOptions) => {
            if (key) {
                loadOptions.filter = ["id", "=", key];
            }
        },
    }));

    const fetchAccountType = (options: { data?: any; }) => {
        const store =  createCustomStore({
            key: 'id',
            load: parameterService.getParameters,
            onLoading(loadOptions) {
                loadOptions.filter = [
                    ["ParentCode", "=", PARENT_PARAMETERS_CONSTANTS.ACCOUNT_TYPE],
                    "and",
                    ["ParentId", "<>", null]
                ];
                if (options.data) {
                    loadOptions.filter = [...loadOptions.filter, ...[
                        "and",
                        ["ApplicationId", "=", options.data.applicationId]],
                    ];
                }

            },
            byKey: (key, loadOptions: any) => {
                if (key) {
                    loadOptions.filter = ["id", "=", key];
                }
            },
        });

        return store;
    };


    const onRowUpdating = async (e: any) => {
        e.newData = { ...e.oldData, ...e.newData }
    };

    const onEditorPreparing = (e: any) => {
        if (e.parentType === 'dataRow') {
            e.row.data.accountId = accountId;
            if (e.dataField === 'parameterAccountTypeId') {
                const isStateNotSet = e.row.data.applicationId === undefined;
                e.editorOptions.disabled = isStateNotSet;
                if (!isStateNotSet) {
                    e.row.data.parameterAccountTypeId = undefined;
                }
            }
            if (e.dataField === 'applicationId') {
                e.row.data.parameterAccountTypeId = undefined;
            }
        }
    };

    return (
        <DataGridWrapper
            datasource={mainStore}
            permissonCode="Admin.Account.Account"
            onRowUpdating={onRowUpdating}
            onEditorPreparing={onEditorPreparing}
            pagerVisible={true}
            enableCustomToolbarContent={false}
            searchPanelVisible={true}
            columnChooser={false}
            headerFilterVisible={true}
            filterVisible={true}
            editingConfig={{
                mode: 'batch',
                allowAdding: true,
                allowDeleting: true,
                allowUpdating: false,
                deleteMessageText: RemoveMessage('Record'),
            }}
            columns={[
                {
                    dataField: 'applicationId',
                    caption: t('application'),
                    required: true,
                    lookup: {
                        dataSource: applicationStore,
                        valueExpr: "id",
                        displayExpr: "name"
                    }
                },
                !accountId && {
                    dataField: 'accountId',
                    caption: t('account'),
                    required: true,
                    lookup: {
                        dataSource: accountStore,
                        valueExpr: "id",
                        displayExpr: "name"
                    }
                },
                {
                    dataField: 'parameterAccountTypeId',
                    caption: t('profile'),
                    required: true,
                    lookup: {
                        dataSource: fetchAccountType as any,
                        valueExpr: "id",
                        displayExpr: "code",
                    }
                }
            ]}
        />
    );
}
export default AccountApplications